import React from "react";
import Helmet from "react-helmet";
import LiveHeader from "../common/LiveHeader";
import { useLive } from "../LiveProvider";
import LiveGuidanceMyRecentSalesListings from "./LiveGuidanceMyRecentSalesListings";
import LiveGuidanceMyRecentSalesMap from "./LiveGuidanceMyRecentSalesMap";
import { Container, RowContainer } from "./styled/live-guidance-details";
import {
  Warning,
  WarningContainer
} from "./styled/live-guidance-my-recent-sales";

function LiveGuidanceMyRecentSales({ pageKey }) {
  const { myRecentSales, getModuleData } = useLive();
  const page = getModuleData(pageKey);

  return (
    <Container id="live" isFullPage className="guidance-container">
      <Helmet>
        <title>{page.title}</title>
      </Helmet>
      <LiveHeader>{page.title}</LiveHeader>
      <RowContainer isFullPage className="guidance-inner-container">
        {!!myRecentSales.length && (
          <>
            <LiveGuidanceMyRecentSalesListings />
            <LiveGuidanceMyRecentSalesMap />
          </>
        )}
        {!myRecentSales.length && (
          <WarningContainer>
            <Warning>
              No recent sales found. Try editing your criteria in the customize
              step.
            </Warning>
          </WarningContainer>
        )}
      </RowContainer>
    </Container>
  );
}

export default LiveGuidanceMyRecentSales;
